import React from 'react'
import DOMPurify from 'dompurify'
import {
  Box,
  Chip,
  Container,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core'

import { Page, ContentHeader, LoadingBox } from 'components'

import useFetch from 'hooks/useFetch'
import constants from 'constants/index'
import * as service from 'service'
import styles from './styles'

const useStyles = makeStyles(styles)

const FaqsDocumentationShow = ({ match }) => {
  const classes = useStyles()
  const faqsDocumentationId = match.params.faqsDocumentationId
  const { response, isLoading } = useFetch(
    service.dponet.faqsDocumentations.get,
    {
      faqsDocumentationId,
    },
  )

  const faqsDocumentation = response?.data?.faqsDocumentation
  const kind =
    faqsDocumentation?.kind === constants.faqsDocumentations.KINDS.FAQ
      ? 'FAQ'
      : 'DOCUMENTAÇÃO'

  const descriptionSanitizer = DOMPurify.sanitize(
    faqsDocumentation?.description,
    {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
    },
  )

  return (
    <Page title={kind}>
      <Container maxWidth={false} className={classes.container}>
        <ContentHeader title={kind}></ContentHeader>
        {isLoading ? (
          <LoadingBox />
        ) : (
          <Paper>
            <Box className={classes.paperContainer}>
              <Box mb={2}>
                <Chip
                  className={
                    faqsDocumentation?.kind ===
                    constants.faqsDocumentations.KINDS.DOCUMENTATION
                      ? classes.faqShow
                      : classes.documentationShow
                  }
                  label={faqsDocumentation?.faqsDocumentationsCategory?.name}
                />
              </Box>
              <Typography variant="h3" align="center">
                {faqsDocumentation?.title}
              </Typography>
              <Typography variant="h4" align="center">
                {faqsDocumentation?.subtitle}
              </Typography>
              <Box
                className={classes.boxDescription}
                textOverflow="hidden"
                fontFamily="Roboto"
                dangerouslySetInnerHTML={{
                  __html: descriptionSanitizer,
                }}
              />
            </Box>
          </Paper>
        )}
      </Container>
    </Page>
  )
}

export default FaqsDocumentationShow
